module.exports = __webpack_public_path__ + "img/1.eb938737.png";